module.exports = __webpack_public_path__ + "static/media/icon.b2a2b549.svg";